import AgencyMaintainService from "../../agency_maintain/service";
import {message} from "antd";

export const RUN_MONITOR_ALERT_SEARCH_TABLE_LIST_IS_LOADING = "RUN_MONITOR_ALERT_SEARCH_TABLE_LIST_IS_LOADING"; // 告警查询表格是否加载中
export const RUN_MONITOR_ALERT_SEARCH_TABLE_LIST = "RUN_MONITOR_ALERT_SEARCH_TABLE_LIST"; // 告警查询表格
export const RUN_MONITOR_ALERT_SEARCH_SET_PROJECT_TYPE = "RUN_MONITOR_ALERT_SEARCH_SET_PROJECT_TYPE"; // 设置项目类型

/**
 * 获取告警列表
 */
export const getAlertList = (params) => {
    return dispatch => {
        dispatch(setTableListISLoading(true));
        AgencyMaintainService.runMonitorAlertSearchService.getAlertList(params).then(json => {
            if(json.code == 0){
                dispatch({
                    type: RUN_MONITOR_ALERT_SEARCH_TABLE_LIST,
                    dataList: json.data.rows,
                    total: json.data.total
                })
            }else{
                message.error(json.msg);
            }
        }).catch(e => {
            console.error("查询告警列表异常:" + e);
            message.error("查询失败");
        }).then(() => dispatch(setTableListISLoading(false)))
    }
}

/**
 * 设置列表是否加载
 */
const setTableListISLoading = isLoading => {
    return {
        type: RUN_MONITOR_ALERT_SEARCH_TABLE_LIST_IS_LOADING,
        isLoading: isLoading
    }
}
/**
 * 设置项目类型
 * @param projectType 项目类型
 * @returns {{projectType: *, type: *}}
 */
export const setProjectType = treeId => {
    return {
        type: RUN_MONITOR_ALERT_SEARCH_SET_PROJECT_TYPE,
        treeId: treeId
    }
}
